import { render, staticRenderFns } from "./ChallengeEdit.vue?vue&type=template&id=93f6fa2a&scoped=true"
import script from "./ChallengeEdit.vue?vue&type=script&lang=js"
export * from "./ChallengeEdit.vue?vue&type=script&lang=js"
import style0 from "./ChallengeEdit.vue?vue&type=style&index=0&id=93f6fa2a&prod&lang=scss"
import style1 from "./ChallengeEdit.vue?vue&type=style&index=1&id=93f6fa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f6fa2a",
  null
  
)

export default component.exports